import { render, staticRenderFns } from "./Manifestos.vue?vue&type=template&id=470cc9f2&"
import script from "./Manifestos.vue?vue&type=script&lang=js&"
export * from "./Manifestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports